import { css } from 'aphrodite';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { CustomerAssistantEditor } from './CustomerAssistantEditor';
import { styles } from './styles';

function AccountCustomerAssistantLoading() {
	return (
		<div className={css(styles.container)}>
			<div className={css(styles.header)}>
				<h1 className={css(styles.title)}>Loading Customer Assistant...</h1>
			</div>
			<LoadingSpinner />
		</div>
	);
}

function AccountCustomerAssistantError() {
	return (
		<div className={css(styles.container)}>
			<div className={css(styles.header)}>
				<h1 className={css(styles.title)}>Error</h1>
			</div>
			<p>Error loading Customer Assistant configuration. Please try again.</p>
		</div>
	);
}

export function AccountCustomerAssistant() {
	const params = useParams<{ accountId: string }>();
	const accountId = params.accountId;

	if (!accountId) {
		return <AccountCustomerAssistantError />;
	}

	return (
		<ErrorBoundary fallback={<AccountCustomerAssistantError />}>
			<React.Suspense fallback={<AccountCustomerAssistantLoading />}>
				<CustomerAssistantEditor accountId={accountId} />
			</React.Suspense>
		</ErrorBoundary>
	);
}
